import React from 'react';
import 'date-fns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker as MuiTimePicker } from '@mui/x-date-pickers/TimePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { FormHelperText, Typography, FormControl, Grid, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import i18n from '../../i18n';
import './styles.scss';
import { getDateLocale } from '../../utils/date';

const StyledFormControl = styled(FormControl)({
  minWidth: '100%',
});

export default function TimePicker(props) {
  const {
    name, label, onChange, variant = 'outlined', required, value, error = null,
    ...others
  } = props;
  return (
    <StyledFormControl
      variant={variant}
      {...(error && { error: 'true', helpertext: error })}
    >
      <Grid container spacing={0} className="mt-8 timePicker">
        {label &&
        <Grid item xs={12} md={4} >
          <Typography
            component="p"
            className={required ? 'inputLabel required' : 'inputLabel'}
          >{label}
          </Typography>
        </Grid>}
        <Grid item xs={12} md={8} >
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={getDateLocale()}>
            <MuiTimePicker
              name={name}
              value={value}
              onChange={(time) => onChange(name, time)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  size="small"
                  error={!!error}
                  {...others}
                />
              )}
            />
          </LocalizationProvider>
          <FormHelperText>{error !== '' && error}</FormHelperText>
        </Grid>
      </Grid>
    </StyledFormControl>
  );
}
